<!-- header section start-->
<div class="header-section">
  <!--logo and logo icon start-->
  <div class="logo bg-light">
    <a>
      <span class="logo-img">
        <img src="assets/new-ui/images/post/logo_small.png" class="mobilelogo" alt="" height="45">
        <img src="assets/images/logo1.svg" class="img-logo hide-box desktoplogo w-100" alt="" height="40">

      </span>
    </a>
  </div>


  <!--toggle button start-->
  <a href="javascript:void(0);" class="toggle-btn" (click)="toggleSideBar($event)">
    <i class="ti ti-menu"></i></a>
  <!--toggle button end-->

  <!--mega menu start-->
  <div id="navbar-collapse-1" *ngIf="!showComponent" class="navbar-collapse collapse mega-menu">
    <ul class="nav navbar-nav">
      <!-- Classic list -->
      <li>
        <form class="search-content" action="index.html" method="post">
          <input type="text" class="form-control mt-3" name="keyword" placeholder="Search...">
          <span class="search-button"><i class="ti ti-search"></i></span>
        </form>
      </li>
    </ul>
  </div>
  <!--mega menu end-->

  <div class="notification-wrap">
    <!--right notification start-->
    <div class="right-notification">
      <ul class="notification-menu">

        <li>

          <a href="javascript:void(0);" data-toggle="dropdown" (click)="getNotifications(true)">
            <!-- <img src="assets/images/icon-bell.png"> -->
            <!-- <img src="assets/images/icon-bell.png" alt=""> -->
            <i class="fa fa-bell" aria-hidden="true"></i>
            <span class="badge badge-danger"
              *ngIf="notificationData?.total_unread > 0">{{notificationData?.total_unread}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right profile-menu item-width" infiniteScroll
            [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [scrollWindow]="false">
            <!-- <li class="dropdown-item" *ngIf="undefined !== user_type && user_type.length == 3"
          [routerLink]="['/profile/user-profile/'+usid]">
          <i class="mdi mdi-account-circle m-r-5 text-muted"></i>
          My Profile</li> -->
            <div *ngIf="notificationData?.notifications && notificationData?.notifications.length > 0">
        <li class="dropdown-item" href="javascript:javascript(0);" *ngFor="let n of notificationData?.notifications"
          [ngClass]="{'bg-color': !n?.read}" (click)="readNoti(n)">
          <div>
            <p class="para">{{n?.message}}</p>
            <span class="float-right"><small class="text-dark">{{n?.created_at | date}},
                {{n?.created_at | date:"HH:mm"}}</small></span>
          </div>
        </li>
    </div>
    <li *ngIf="!notificationData?.notifications || notificationData?.notifications.length === 0" class="dropdown-item">
      No Notifications !
    </li>
  </div>

  </li>
  <li>

    <a href="javascript:void(0);" data-toggle="dropdown">
      <img [src]="userImg" alt="">&nbsp;<b>{{display_name}}</b>
    </a>

    <div class="dropdown-menu dropdown-menu-right profile-menu">
      <!-- <li class="dropdown-item" *ngIf="undefined !== user_type && user_type.length == 3"
          [routerLink]="['/profile/user-profile/'+usid]">
          <i class="mdi mdi-account-circle m-r-5 text-muted"></i>
          My Profile</li> -->
  <li class="dropdown-item" href="javascript:javascript(0);" *ngIf="this.checkutype"
    [routerLink]="['/profile/physicians-profile/'+usid]">
    <i class="mdi mdi-account-circle m-r-5 text-muted"></i>
    My Profile
  </li>
  <li class="dropdown-item" href="javascript:javascript(0);" *ngIf="this.checkutype" [routerLink]="['/myfiles']">
    <i class="mdi mdi-file-multiple m-r-5 text-muted"></i>
    My Files
  </li>
  <li class="dropdown-item" href="javascript:javascript(0);" *ngIf="checkutype"
    [routerLink]="['/physician/transaction']">
    <i class="mdi mdi-wallet m-r-5 text-muted"></i>
    My Transactions
  </li>

  <li class="dropdown-item" href="javascript:javascript(0);" *ngIf="!checkutype && checkutype2"
    [routerLink]="['/profile/user-profile/'+usid]">
    <i class="mdi mdi-account-circle m-r-5 text-muted"></i>
    My Profile
  </li>
  <li class="dropdown-item" (click)=logout()><i class="mdi mdi-logout m-r-5 text-muted"></i> Logout</li>
</div>

</li>

</ul>
</div>
<!--right notification end-->
</div>
</div>
<!-- header section end-->